import { createActions } from 'redux-actions';
import { END_DATE } from '../actionTypes';

export default createActions({
  [END_DATE]: (state) => {
    return state;
  }
});
